import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getCurrencies() {
  const data = await apiGet('helper/currencies');
  useHelperStore().setCurrencies(data);
}
